/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { useTranslation } from "react-i18next";
import { useEffect, useRef, useState } from "react";
import { LinkArr, Next, Prev, TenderSvg } from "../../../common/svg/AllSvg";
import Slider from "react-slick";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import useAxios from "../../../../shared/hooks/use-axios";
import { url } from "../../../../shared/utils/url";
import Img1 from "../../../../assets/images/news5.png";
import Img2 from "../../../../assets/images/news6.png";

const RecentUpdates = ({ data }: any) => {
    const { t } = useTranslation('common');
    const lang: string = useSelector((state: any) => state.ui.lang);
    const newsRef: any = useRef(null);
    const tendersRef: any = useRef(null);
    const [tenderData, setTenderData] = useState<any[]>([]);
    const [loading, setLoading] = useState(true);
    const [loading1, setLoading1] = useState(true);
    const [newsData, setNewsData] = useState<any[]>([]);
    const navigate = useNavigate();
    const params = useParams();

    const settings = {
        dots: false,
        arrows: false,
        infinite: newsData?.length > 2 ? true : false,
        autoplay: false,
        autoplaySpeed: 3000,
        pauseOnHover: true,
        slidesToShow: 2,
        slidesToScroll: 2,
        responsive: newsData?.length > 2 ? [
            {
                breakpoint: 1050,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                }
            },
            {
                breakpoint: 900,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }
            }
        ] : [{
            breakpoint: 768,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
            }
        }]
    }

    const settings1 = {
        dots: false,
        arrows: false,
        infinite: true,
        autoplay: false,
        autoplaySpeed: 3000,
        pauseOnHover: true
    }

    const getTenderData = async () => {
        try {
            setLoading(true)
            const res: any = await useAxios.get(`/${(!!lang ? lang : "en") + url?.tendersList}`);

            if (res && res?.status === 200) {
                setTenderData(res?.data?.results)
                setLoading(false)
            }
        } catch (error) {
            setLoading(false)
            console.error("error while feching tender data", error);
        }
    };

    const getNews = async () => {
        try {
            setLoading1(true)
            const res: any = await useAxios.get(`/${(!!lang ? lang : "en") + url.news_list}?page=1&size=10`);

            if (res && res.status === 200) {
                setNewsData(res?.data?.results)
                setLoading1(false)
            }
        } catch (error) {
            setLoading1(false)
            console.error("error while fetching news", error);
        }
    }

    useEffect(() => {
        !!lang && getTenderData();
        !!lang && getNews();
    }, [lang])

    const chunkedData = [];
    for (let i = 0; i < tenderData.length; i += 3) {
        chunkedData.push(tenderData.slice(i, i + 3));
    }

    return (
        <div className="w-full h-full flex items-center justify-center mt-[-60px] z-[1] relative">
            <div className="container corporate-banner-container mdm:!w-[1200px] xlx:!w-[1384px] grid grid-cols-2 llg:grid-cols-4">
                <div className="w-full col-span-2 bg-[#F6F6F6] pt-[25px] xlx:pt-[27px] px-[25px] mdm:px-[30px] xlx:px-[40px] pb-[25px] mdm:pb-[30px] flex flex-col">
                    <div className="flex items-center justify-between gap-[15px]">
                        <div className="flex items-center gap-[10px]">
                            <div className="min-w-[9px] h-[9px] w-[9px] bg-primary mb-[1px]"></div>
                            <h5 className="text-primary font-semibold uppercase">{t("corporate.banner.recent_news")}</h5>
                        </div>

                        {/* <div className="flex items-center gap-[5px] pr-[25px]">
                            <button aria-label={t("aria_label.prev_arr")} title={t("aria_label.prev")} className="min-w-[22px] h-[22px] flex items-center justify-center rounded-full focus:shadow-[0_0_0_1px_#059DB25e] hover:shadow-[0_0_0_1px_#059DB25e]" onClick={() => newsRef.current.slickPrev()}>
                                <Prev className="fill-primary min-w-[14px] w-[14px] h-[13px]" />
                            </button>
                            <button aria-label={t("aria_label.next_arr")} title={t("aria_label.next")} className="min-w-[22px] h-[22px] flex items-center justify-center rounded-full focus:shadow-[0_0_0_1px_#059DB25e] hover:shadow-[0_0_0_1px_#059DB25e]" onClick={() => newsRef.current.slickNext()}>
                                <Next className="fill-primary min-w-[14px] w-[14px] h-[13px]" />
                            </button>
                        </div> */}
                    </div>
                    {/* <div className="w-full flex mt-[20px] md:mt-[22px] xlx:mt-[30px]">
                        <Slider className="w-full h-full" ref={newsRef} {...settings}>
                            {Array?.isArray(newsData) && newsData?.map((item: any, index: number) => (
                                <div className="w-full llg:min-w-[250px] llg:w-[250px] xlx:min-w-[287px] xlx:w-[287px] h-full !flex flex-col gap-[8px] md:gap-[12px] xlx:gap-[15px] pr-[15px] mdm:pr-[25px]" key={index}>
                                    <h4 className="font-bold text-primaryText line-clamp-2 min-h-[43px] xlx:min-h-[51px]">{item?.description}</h4>

                                    <img src={(!!!item?.image?.file ? item?.image?.file : (index + 1) % 3 === 1 ? Img1 : (index + 1) % 3 === 2 ? Img2 : (index + 1) % 3 === 3 ? Img3 : Img4)} alt={item?.description} className={`llg:w-[250px] xlx:w-[287px] h-[190px] xlx:h-[213px] mt-[4px] ${!!item?.image?.file && 'news-img opacity-[0.6]'}`} />
                                </div>
                            ))}
                        </Slider>
                    </div> */}

                    <div className="grid grid-cols-1 xsm:grid-cols-2 w-full gap-[15px] mdm:gap-[20px] xlx:gap-[25px] mt-[20px] md:mt-[22px] xlx:mt-[30px]">
                        {loading1 ?
                            <>
                                {Array?.isArray([1, 2]) && [1, 2]?.map((item: any, index: number) => (
                                    <div className="w-full h-full flex flex-col gap-[8px] md:gap-[12px] xlx:gap-[15px] animate-pulse" key={index}>
                                        <div className="w-[70%] h-[12px] bg-gray-200 rounded-full dark:bg-gray-700"></div>

                                        <div className="w-full h-[190px] xlx:h-[213px] mt-[4px] bg-gray-200 dark:bg-gray-700"></div>
                                    </div>
                                ))}
                            </>
                            : <>
                                {Array?.isArray(newsData) && newsData?.slice(0, 2)?.map((item: any, index: number) => (
                                    <div className="w-full h-full flex flex-col gap-[8px] md:gap-[12px] xlx:gap-[15px]" key={index}>
                                        <h4 className="font-bold text-primaryText">{!!item?.title ? item?.title : item?.description}</h4>

                                        <Link to={item?.upload_news?.url} target="_blank" className="img-zoom overflow-hidden">
                                            <img src={(!!item?.image?.url ? item?.image?.url : (index + 1) % 2 === 1 ? Img1 : Img2)} alt={item?.title} className="w-full h-[200px] xlx:h-[250px] mt-[4px]" />
                                        </Link>
                                    </div>
                                ))}
                            </>}
                    </div>

                    <div className="w-full flex items-end justify-end mt-[20px] md:mt-[22px] xlx:mt-[25px] pr-[25px]">
                        <button className="text-primaryText font-medium text-sm flex items-center gap-[8px] focus:underline hover:underline uppercase" onClick={() => !!params?.lang ? navigate(`/${params?.lang}/news`) : navigate(`/news`)}>
                            {t("corporate.banner.view_all")}
                            <div className="pb-[1px]">
                                <LinkArr className="fill-primaryText min-w-[8px] w-[8px] h-[8px]" />
                            </div>
                        </button>
                    </div>
                </div>

                <div style={{ background: "linear-gradient(250deg, #FCAB02 22.56%, #F39C05 82.21%)" }} className="w-full bg-[#F6F6F6] p-[25px] xlx:p-[27px] flex flex-col gap-[20px] md:gap-[22px] md:col-span-1 col-span-2">
                    <div className="flex items-center gap-[10px]">
                        <div className="min-w-[9px] h-[9px] w-[9px] bg-white mb-[1px]"></div>
                        <h5 className="text-white font-semibold uppercase">{data?.section_one?.data?.[0]?.title}</h5>
                    </div>

                    <div className="flex flex-col gap-[20px] md:gap-[22px] w-full h-full justify-between">
                        <h3 className="text-white font-semibold text-[1.125rem] text-justify *:text-white *:font-semibold line-clamp-[11] xlx:line-clamp-[12] *:text-[1.125rem] *:text-justify" dangerouslySetInnerHTML={{ __html: data?.section_one?.data?.[0]?.content }} />

                        <div className="flex flex-col gap-[20px] md:gap-[22px] w-full">
                            {/* <div className="flex items-center gap-[15px] justify-between w-full">
                                <div className="flex items-center gap-[15px]">
                                    <div className="min-w-[50px] h-[50px] rounded-full flex items-center justify-center bg-white">
                                        <img src={data?.section_one?.data?.[0]?.icon?.file} alt="icon-img" />
                                    </div>

                                    <div className="flex flex-col about_us_icon_text" dangerouslySetInnerHTML={{ __html: data?.section_one?.data?.[0]?.icon_text }} />
                                </div>

                                <div className="min-w-[50px] h-[50px] rounded-full flex items-center justify-center bg-white bg-opacity-[0.2]">
                                    <img src={data?.section_one?.data?.[0]?.right_icon?.file} alt="icon-img" />
                                </div>
                            </div> */}

                            <div className="w-full flex items-start justify-start">
                                <button className="text-white font-medium text-sm flex items-center gap-[8px] focus:underline hover:underline uppercase" onClick={() => !!params?.lang ? navigate(`/${params?.lang}/about-us`) : navigate(`/about-us`)}>
                                    {t("corporate.banner.view_more")}
                                    <div className="pb-[1px]">
                                        <LinkArr className="fill-white min-w-[8px] w-[8px] h-[8px]" />
                                    </div>
                                </button>
                            </div>
                        </div>
                    </div>

                </div>

                <div className="w-full bg-primaryText p-[25px] xlx:py-[27px] xlx:px-[30px] flex flex-col gap-[20px] md:gap-[22px] md:col-span-1 col-span-2">
                    <div className="flex items-center gap-[10px]">
                        <div className="min-w-[9px] h-[9px] w-[9px] bg-white mb-[1px]"></div>
                        <h5 className="text-white font-semibold uppercase">{t("corporate.banner.recent_tenders")}</h5>
                    </div>

                    <div className="flex flex-col h-full justify-between gap-[15px]">
                        {loading ?
                            <div className="!flex !flex-col gap-[15px] md:gap-[25px] xlx:gap-[30px]">
                                {Array?.isArray([1, 2, 3]) && [1, 2, 3]?.map((item: any, index: number) => (
                                    <div className="flex flex-col gap-[10px] w-full animate-pulse" key={index}>
                                        <div className="w-full h-[12px] bg-gray-200 rounded-full dark:bg-gray-700"></div>
                                        <div className="w-full h-[12px] bg-gray-200 rounded-full dark:bg-gray-700"></div>
                                        <div className="w-[60%] h-[12px] bg-gray-200 rounded-full dark:bg-gray-700"></div>
                                    </div>
                                ))}
                            </div>
                            :
                            <Slider className="w-full h-full" ref={tendersRef} {...settings1}>
                                {Array?.isArray(chunkedData) && chunkedData?.map((item: any, index: number) => (
                                    <div className="!flex !flex-col gap-[15px] md:gap-[25px] xlx:gap-[30px]" key={index}>
                                        {Array?.isArray(item) && item.map((i: any, idx: number) => (
                                            <div className="!flex gap-[10px] w-full" key={idx}>
                                                <TenderSvg />

                                                <Link to={i?.documents?.url} target="_blank" className="focus:underline hover:underline text-white text-lg font-semibold line-clamp-3 focus:*:underline hover:*:underline *:text-white *:text-lg *:font-semibold *:line-clamp-3 mt-[-6px]" dangerouslySetInnerHTML={{ __html: i?.content }} />
                                            </div>
                                        ))}
                                    </div>
                                ))}
                            </Slider>
                        }


                        <div className="w-full flex items-center justify-between">
                            <button className="text-white font-medium text-sm flex items-center gap-[8px] focus:underline hover:underline uppercase" onClick={() => !!params?.lang ? navigate(`/${params?.lang}/tenders`) : navigate(`/tenders`)} >
                                {t("corporate.banner.view_all")}
                                <div className="pb-[1px]">
                                    <LinkArr className="fill-white min-w-[8px] w-[8px] h-[8px]" />
                                </div>
                            </button>

                            <div className="flex items-center gap-[5px]">
                                <button aria-label={t("aria_label.prev_arr")} title={t("aria_label.prev")} className="min-w-[22px] h-[22px] flex items-center justify-center rounded-full focus:shadow-[0_0_0_1px_#ffffff5e] hover:shadow-[0_0_0_1px_#ffffff5e]" onClick={() => tendersRef.current.slickPrev()}>
                                    <Prev className="fill-white min-w-[14px] w-[14px] h-[13px]" />
                                </button>
                                <button aria-label={t("aria_label.next_arr")} title={t("aria_label.next")} className="min-w-[22px] h-[22px] flex items-center justify-center rounded-full focus:shadow-[0_0_0_1px_#ffffff5e] hover:shadow-[0_0_0_1px_#ffffff5e]" onClick={() => tendersRef.current.slickNext()}>
                                    <Next className="fill-white min-w-[14px] w-[14px] h-[13px]" />
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div >
    );
};

export default RecentUpdates;